import React, { useContext, useState } from 'react';
import { faCommentExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage, injectIntl } from 'react-intl';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { StyledPhoneInput } from 'components/Campaigns/CampaignOverview/SendMessageSideDrawer/SendThroughForm/PhoneInput/styles';
import ErrorDisplay from 'components/Campaigns/CampaignOverview/SendMessageSideDrawer/SendThroughForm/ErrorDisplay';
import { UserContext } from '../../../stores';
import { FormContentGroup, StyledButton } from '../LoginFormSection/styles';
import { ContentContainer, TwoFactorAuthSubtitle } from './styles';
import RoundIcon from '../../../components/RoundIcon';

function ChangePhoneNumberContent({ intl: { formatMessage } }) {
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [touched, setTouched] = useState(false);
  const userStore = useContext(UserContext);

  const onSubmit = () => {
    // We won't submit if the phone number is invalid
    if (!isValidPhoneNumber(phoneNumber)) return;

    userStore.changePhoneNumber(phoneNumber);
  };

  return (
    <ContentContainer>
      <RoundIcon icon={faCommentExclamation} />

      <TwoFactorAuthSubtitle>
        <FormattedMessage id="pages/Login/TwoFactorAuthenticationModal/changePhoneNumber/description" />
      </TwoFactorAuthSubtitle>

      <FormContentGroup width="300px" centered>
        <StyledPhoneInput
          value={phoneNumber}
          onChange={(phoneNumber) => setPhoneNumber(phoneNumber)}
          onTouched={() => setTouched(true)}
          touched={touched}
        />

        {userStore.loginRequestErrorCode && (
          <ErrorDisplay
            errorMessage={formatMessage({
              id: `pages/Login/TwoFactorAuthenticationModal/error/${userStore.loginRequestErrorCode}`,
            })}
          />
        )}
      </FormContentGroup>

      <StyledButton width="300px" onClick={onSubmit} centered>
        <FormattedMessage id="pages/Login/TwoFactorAuthenticationModal/code/continue" />
      </StyledButton>
    </ContentContainer>
  );
}

export default injectIntl(ChangePhoneNumberContent);
